const lang = {
    public:{
        add:'添加',
        edit:"编辑",
        confirmDelete:'确定删除',
        delete:"删除",
        multiDelete:'批删除',
        hide:'隐藏',
        save:'保存',
        close:'关闭',
        screen:'本地筛选'
    },
    key:{
        currentPathTips:'key路径，只能是路径不能是值',
        delConfirm:'确定删除选中的key？',
        notSubKey:'没有子级列表!',
        addKey:'添加key',
        editKey:'编辑key',
        open:'打开',
        show:'查看',
        keyNotEmpty:'key不能为空',
        addSuccessfully:'添加成功！',
        saveSuccessfully:'保存成功！'
    },
    logs:{
        date:'日期',
        user:'用户',
        typeof:'类型',
        filter:'筛选',
        selectDate:'请选择日期',
        selectDateShowLog:'选择日期查看日志',
    },
    etcdServer:{
        repairDirectory:'修复目录',
        determineRepairDirectory:'确定修复etcd key的目录问题',
    }
}

export default lang;
